import React from 'react';
import _isEqual from 'lodash/isEqual';
import _pickBy from 'lodash/pickBy';
import * as Types from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/typings';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import TimezoneAndWorkHoursForm from './TimezoneAndWorkHoursForm';

interface Props {
  timezoneAndWorkHours: Types.TimezoneAndWorkHoursFormState;
  errors: any;
  onChange: (key: string, value: any) => void;
}

function TimezoneAndWorkHours({ timezoneAndWorkHours, errors, onChange }: Props) {
  return (
    <Card>
      <CardHeader
        title="Time Zone and Work Schedule"
        subheader="Enabling work schedule will allow users to add their daily working hours and work location to their profile."
      />
      <Divider />
      <CardContent>
        <TimezoneAndWorkHoursForm
          value={timezoneAndWorkHours}
          onChange={onChange}
          errors={errors}
        />
      </CardContent>
    </Card>
  );
}

export default TimezoneAndWorkHours;
